import React from "react";
import { useTranslate } from "react-admin";

const StockTitle = ({ record }) => {
    const translate = useTranslate();

    return (
        <span>
            {
                ! record ?    translate("stock.message.list") :
                ! record.id ? translate("stock.message.new") :
                              translate("stock.message.instance", { ...record })
            }
        </span>
    );
}

export default StockTitle;
